import React from 'react';
import { ApiTypes } from '@flashbacktech/flashbackclient/api';
import S3Fields from './S3Fields';
import GCSFields from './GCSFields';
import AzureBlobFields from './AzureBlobFields';

export interface S3FieldsType {
  bucket: string;
  accessKey: string;
  secret: string;
  endpoint: string;
  region: string;
}

export interface GCSFieldsType {
  bucket: string;
  clientEmail: string;
  privateKey: string;
  endpoint: string;
}

export interface AzureFieldsType {
  storageAccount: string;
  container: string;
  accessKey: string;
}

interface StorageTypeFieldsProps {
  storageType: ApiTypes.StorageType;
  s3Fields: S3FieldsType;
  gcsFields: GCSFieldsType;
  azureFields: AzureFieldsType;
  validationErrors: {
    key?: string;
    secret?: string;
    region?: string;
    clientEmail?: string;
    privateKey?: string;
    storageAccount?: string;
    container?: string;
    accessKey?: string;
  };
  onChange: (field: string, value: string) => void;
  isEdit?: boolean;
}

const StorageTypeFields: React.FC<StorageTypeFieldsProps> = ({
  storageType,
  s3Fields,
  gcsFields,
  azureFields,
  validationErrors,
  onChange,
  isEdit = false,
}) => {
  switch (storageType) {
    case ApiTypes.StorageType.S3:
      return (
        <S3Fields
          bucket={s3Fields.bucket}
          accessKey={s3Fields.accessKey}
          secret={s3Fields.secret}
          endpoint={s3Fields.endpoint}
          region={s3Fields.region}
          validationErrors={validationErrors}
          onChange={onChange}
          isEdit={isEdit}
        />
      );
    case ApiTypes.StorageType.GCS:
      return (
        <GCSFields
          bucket={gcsFields.bucket}
          clientEmail={gcsFields.clientEmail}
          privateKey={gcsFields.privateKey}
          endpoint={gcsFields.endpoint}
          validationErrors={validationErrors}
          onChange={onChange}
          isEdit={isEdit}
        />
      );
    case ApiTypes.StorageType.BLOB:
      return (
        <AzureBlobFields
          storageAccount={azureFields.storageAccount}
          container={azureFields.container}
          accessKey={azureFields.accessKey}
          validationErrors={validationErrors}
          onChange={onChange}
          isEdit={isEdit}
        />
      );
    default:
      return null;
  }
};

export default StorageTypeFields;
